module.exports = __webpack_public_path__ + "img/input-count-minus.4c436fcf.svg";